import {IsoDate} from "../../../../pseudo-types/DateTypes";
import {AccountMarginSummaries, AccountMarginSummary} from "../../../models/AccountPerformanceSummary";
import {DateTimeUtil} from "../../../../js/util/DateTimeUtil";

/*
 * For the Opening Summary we need to get the MarginSummary for the day before the start period
 * as our summaries are EOD
 */
export function openingSummary(asAt: IsoDate, marginHistory: AccountMarginSummaries): AccountMarginSummary {
    const asAtSummaryIndex = marginHistory.findIndex((h) => DateTimeUtil.isoDate(h.asAt) >= asAt);
    const index = Math.max(0, asAtSummaryIndex - 2);
    return marginHistory[index];
}

export function closingSummary(asAt: IsoDate, marginHistory: AccountMarginSummaries): AccountMarginSummary {
    const historyStart = marginHistory.findIndex((h) => DateTimeUtil.isoDate(h.asAt) >= asAt);
    const index = Math.max(0, historyStart);
    return marginHistory[index];
}
